
import React from 'react';
import { HelpCircle } from 'lucide-react';
import { useChatHistory } from '@/hooks/useChatHistory';
import ChatHistoryItem from './ChatHistoryItem';

interface SidebarChatHistoryProps {
  open: boolean;
  handleOpenChat: (chatId: string) => void;
  handleDeleteClick: (chatId: string) => void;
}

export const SidebarChatHistory: React.FC<SidebarChatHistoryProps> = ({
  open,
  handleOpenChat,
  handleDeleteClick
}) => {
  const { chatHistory, isLoadingChats } = useChatHistory();

  return (
    <div className="flex-grow border-t border-gray-800 pt-4 mt-4 overflow-auto">
      {open && (
        <div className="flex justify-between items-center mb-4">
          <p className="text-gray-500 text-sm px-2">Vergangene Chats</p>
          <HelpCircle className="h-4 w-4 text-gray-500 mr-2" />
        </div>
      )}
      
      <div className="space-y-1 px-2">
        {isLoadingChats ? (
          <div className="text-gray-500 text-sm text-center py-2">
            Lädt...
          </div>
        ) : chatHistory.length > 0 ? (
          chatHistory.map((chat) => (
            <ChatHistoryItem 
              key={chat.id}
              id={chat.id}
              title={chat.title}
              updated_at={chat.updated_at}
              has_signed_document={chat.has_signed_document}
              onOpenChat={handleOpenChat}
              onDeleteClick={(e, chatId) => {
                e.stopPropagation();
                handleDeleteClick(chatId);
              }}
            />
          ))
        ) : (
          <div className="text-gray-500 text-sm text-center py-2">
            Keine vergangenen Chats
          </div>
        )}
      </div>
    </div>
  );
};
